<!-- components/Aceites/TuEsperaAceite.vue -->
<template>
  <section :class="clases.seccion">
    <div :class="clases.contenedor">
      <!-- BLOQUE 1: HAZ DE TU ESPERA -->
      <div>
        <div :class="[clases.grid_base, clases.grid_top]">
          <!-- Texto -->
          <div :class="clases.texto_base">
            <h3 :class="clases.titulo_principal">
              HAZ DE TU ESPERA UN BUEN MOMENTO
            </h3>

            <p :class="clases.parrafo">
              En nuestros locales pensamos en cada detalle para que tu experiencia sea cómoda y agradable.
            </p>

            <p :class="clases.parrafo_sin_mb">
              Mientras realizamos el servicio, puedes disfrutar de un café de grano de cortesía,
              conectarte a nuestro wifi y trabajar desde tu computador o simplemente relajarte
              en un espacio climatizado.
            </p>
          </div>

          <!-- Media -->
          <div>
            <div
              :class="[clases.frame_base, clases.frame_panoramico]"
              aria-label="Galería sala de espera"
            >
              <img
                :src="imagenes_espera[indice_espera].src"
                :alt="imagenes_espera[indice_espera].alt"
                :class="clases.media_img"
                loading="lazy"
                decoding="async"
              />

              <div
                v-if="imagenes_espera.length > 1"
                :class="clases.dots"
                role="tablist"
                aria-label="Galería sala de espera"
              >
                <button
                  v-for="(_, i) in imagenes_espera"
                  :key="i"
                  type="button"
                  :class="[
                    clases.dot_base,
                    i === indice_espera ? clases.dot_activo : ''
                  ]"
                  :aria-label="`Ir a imagen ${i + 1}`"
                  :aria-selected="i === indice_espera"
                  role="tab"
                  @click="set_indice_espera(i)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- BLOQUE 2: CAMBIO DE ACEITE -->
      <div>
        <!-- Título MOBILE (arriba de la imagen) -->
        <h3 :class="[clases.titulo_principal, 'md:hidden text-center mb-[14px]']">
          CAMBIO DE ACEITE
        </h3>

        <div :class="[clases.grid_base, clases.grid_center]">
          <!-- Media -->
          <div>
            <div :class="[clases.frame_base, clases.frame_normal]">
              <img
                src="/img/aceites/imagenes/maestro1.png"
                alt="Servicio de cambio de aceite LEÓN"
                :class="clases.media_img"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>

          <!-- Texto -->
          <div :class="[clases.texto_base, 'md:text-left']">
            <!-- Título DESKTOP (a la derecha) -->
            <h3 :class="[clases.titulo_principal, 'hidden md:block']">
              CAMBIO DE ACEITE
            </h3>

            <p :class="clases.parrafo">
              El cambio de aceite y filtro es clave para la mantención de tu auto.
              Hacerlo en los plazos recomendados por el fabricante evita fallas graves
              en el motor y asegura su mejor rendimiento.
            </p>

            <p :class="clases.destacado">
              Aquí te contamos con breves Tips lo esencial de este servicio.
            </p>
          </div>
        </div>
      </div>

    </div>
  </section>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue'

const clases = {
  // Sección / contenedor (equivalente a tu <style scoped>)
  seccion: 'w-full bg-BLANCO_LEON',

  contenedor: [
    'max-w-[1240px] mx-auto flex flex-col',
    'gap-[64px] md:gap-[92px]',
    'px-[22px] md:px-[64px] lg:px-[32px]',
    'pt-[52px] md:pt-[86px] lg:pt-[72px]',
    'pb-[62px] md:pb-[96px] lg:pb-[84px]'
  ].join(' '),

  // Grid base y variantes
  grid_base: [
    'grid grid-cols-1 md:grid-cols-2',
    'gap-y-[22px] md:gap-y-[28px]',
    'md:gap-x-[88px] lg:md:gap-x-[56px]', // lg (1024) reduce gap-x
    'min-w-0'
  ].join(' '),

  grid_top: 'items-start',
  grid_center: 'items-center',

  // Texto
  texto_base: [
    'max-w-full md:max-w-[560px]',
    'text-center md:text-left'
  ].join(' '),

  titulo_principal: [
    'text-ROJO_LEON',
    'font-extrabold uppercase',
    'leading-[1.15]',
    'tracking-[0.035em] md:tracking-[0.04em]',
    'text-[20px] md:text-[30px]',
    'mb-[14px] md:mb-[18px]'
  ].join(' '),

  parrafo: [
    'text-GRIS_LEON',
    'text-[15px] md:text-[16px]',
    'leading-[1.85] md:leading-[1.9]',
    'mb-[14px] md:mb-[18px]'
  ].join(' '),

  parrafo_sin_mb: [
    'text-GRIS_LEON',
    'text-[15px] md:text-[16px]',
    'leading-[1.85] md:leading-[1.9]'
  ].join(' '),

  destacado: [
    'text-GRIS_LEON font-extrabold',
    'text-[18px] md:text-[16px]',
    'leading-[1.55] md:leading-[1.6]',
    'mt-[16px] md:mt-[10px]'
  ].join(' '),

  // Frames / imágenes
  frame_base: [
    'relative w-full overflow-hidden',
    'rounded-[18px] md:rounded-[22px]',
    'bg-GRIS_TARJETAS'
  ].join(' '),

  frame_panoramico: 'aspect-[16/9] md:aspect-[21/9]',
  frame_normal: 'aspect-[16/9]',

  media_img: 'w-full h-full block object-cover',

  // Dots
  dots: [
    'absolute left-1/2 -translate-x-1/2',
    'bottom-[12px] md:bottom-[16px]',
    'flex items-center justify-center gap-[12px]'
  ].join(' '),

  dot_base: [
    'w-[10px] h-[10px] rounded-full border-0 cursor-pointer',
    'bg-white/55',
    'shadow-[0_0_0_1px_rgba(0,0,0,0.10)]'
  ].join(' '),

  dot_activo: 'bg-white/95 scale-[1.12]'
}

/**
 * Mockup: 4 dots
 */
const imagenes_espera = ref([
  { src: '/img/aceites/imagenes/img-1.png', alt: 'Sala de espera LEÓN (1)' },
  { src: '/img/aceites/imagenes/img-1.png', alt: 'Sala de espera LEÓN (2)' },
  { src: '/img/aceites/imagenes/img-1.png', alt: 'Sala de espera LEÓN (3)' },
  { src: '/img/aceites/imagenes/img-1.png', alt: 'Sala de espera LEÓN (4)' }
])

const indice_espera = ref(0)

function set_indice_espera(nuevo_indice) {
  if (nuevo_indice < 0 || nuevo_indice >= imagenes_espera.value.length) return
  indice_espera.value = nuevo_indice
}

let intervalo = null

function puede_autoplay() {
  if (typeof window === 'undefined') return false
  const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches
  return !reduced
}

onMounted(() => {
  if (imagenes_espera.value.length <= 1) return
  if (!puede_autoplay()) return

  intervalo = setInterval(() => {
    indice_espera.value = (indice_espera.value + 1) % imagenes_espera.value.length
  }, 6000)
})

onBeforeUnmount(() => {
  if (intervalo) clearInterval(intervalo)
})
</script>
